import React, { SVGProps } from 'react';

export const GrowthIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 29,
  height = 19,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 29 19"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.55 17.1H26.1V2.85C26.1 2.59804 25.9472 2.35641 25.6753 2.17825C25.4034 2.00009 25.0346 1.9 24.65 1.9C24.2654 1.9 23.8966 2.00009 23.6247 2.17825C23.3528 2.35641 23.2 2.59804 23.2 2.85V17.1H20.3V6.65C20.3 6.39804 20.1472 6.15641 19.8753 5.97825C19.6034 5.80009 19.2346 5.7 18.85 5.7C18.4654 5.7 18.0966 5.80009 17.8247 5.97825C17.5528 6.15641 17.4 6.39804 17.4 6.65V17.1H14.5V10.45C14.5 10.198 14.3472 9.95641 14.0753 9.77825C13.8034 9.60009 13.4346 9.5 13.05 9.5C12.6654 9.5 12.2966 9.60009 12.0247 9.77825C11.7528 9.95641 11.6 10.198 11.6 10.45V17.1H8.7V14.25C8.7 13.998 8.54723 13.7564 8.2753 13.5782C8.00338 13.4001 7.63456 13.3 7.25 13.3C6.86544 13.3 6.49662 13.4001 6.2247 13.5782C5.95277 13.7564 5.8 13.998 5.8 14.25V17.1H2.9V0.95C2.9 0.698044 2.74723 0.456408 2.47531 0.278249C2.20338 0.100089 1.83456 0 1.45 0C1.06544 0 0.696623 0.100089 0.424695 0.278249C0.152767 0.456408 0 0.698044 0 0.95V18.05C0 18.302 0.152767 18.5436 0.424695 18.7218C0.696623 18.8999 1.06544 19 1.45 19H27.55C27.9346 19 28.3034 18.8999 28.5753 18.7218C28.8472 18.5436 29 18.302 29 18.05C29 17.798 28.8472 17.5564 28.5753 17.3782C28.3034 17.2001 27.9346 17.1 27.55 17.1Z"
        fill="#C33838"
      />
    </svg>
  );
};
